import { envConfig } from './env';

export const salesforceConfig = {
  instanceUrl: 'https://euqueroinvestir.my.site.com',
  salesforceChat: {
    isAvailable: true,
    chatName: envConfig.salesforce.chat.chatName,
    queueId: envConfig.salesforce.chat.queueId,
    queueName: envConfig.salesforce.chat.queueName,
    scrt2URL: 'https://euqueroinvestir.my.salesforce-scrt.com',
  },
};

export const salesforceOpportunityConfig = {
  FP: {
    myGoals: {
      default: {
        action: 'FP',
        product: 'Preciso de ajuda',
      },
      empty: {
        action: 'FP',
        product: 'Gostaria de cadastrar meus objetivos',
      },
      noContribuition: {
        action: 'FP',
        product: 'Meu objetivo está sem aporte',
      },
      newContribuition: {
        action: 'FP',
        product: 'Gostaria de fazer um novo aporte',
      },
      talkWithPlanner: {
        action: 'FP',
        product: 'Falar com o planejador',
      },
    },
    myNetWorth: {
      imobilized: {
        empty: {
          action: 'FP',
          product: 'Gostaria de adicionar um bem imobilizado',
        },
      },
    },
    myRetirement: {
      empty: {
        action: 'FP',
        product: 'Quero cenários de aposentadoria',
      },
    },
    fpHub: {
      opportunity: {
        action: 'FP',
        product: 'Gostaria de conhecer o Planejador Financeiro',
      },
    },
  },
  banking: {
    business: {
      credit: {
        action: 'Crédito',
      },
      freeMarket: {
        action: 'Energia',
      },
    },
    content: {
      action: 'conta',
      product: 'Abertura de conta',
    },
    creditCard: {
      action: 'Crédito',
      product: 'Cartão',
    },
    exchange: {
      action: 'Câmbio',
    },
    goodsAcquisition: {
      realEstateFinancing: {
        action: 'Consórcio',
        product: 'Financiamento',
      },
      homeEquity: {
        action: 'Consórcio',
        product: 'Home Equity',
      },
      consortium: {
        action: 'Consórcio',
        product: 'Consórcio',
      },
    },
    invest: {
      action: 'Boletador',
    },
    lifeInsurance: {
      action: 'Seguros',
      product: 'Seguro',
    },
    openAccount: {
      action: 'conta',
      product: 'Abertura de conta',
    },
    pension: {
      action: 'Previdência',
    },
    variableIncome: {
      action: 'RV',
      product: 'Renda variável',
    },
  },
  sendClickEvent: {
    welcome: {
      label: (label: string) => `Bem Vindo|${label}`,
    },
    sideMenu: {
      label: (label: string) => `Menu|${label}`,
    },
    bannerCarrouselCourseMovies: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    recommnendation: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    myAdvisor: {
      label: (url: string) => `Fale com o assessor|${url}`,
    },
    myAdvisorIsClient: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    researchContent: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    invest: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    openAccount: {
      label: (url: string) => `Abra sua conta na EQI|${url}`,
    },
    lifeInsurance: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    variableIncomeAdvisor: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    BusinessCredit: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    freeMarket: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    creditCard: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    exchange: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    goodsAquisition: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    homeEquity: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    realEstateFinancing: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    exclusiveServices: {
      label: (label: string) => label,
    },
    myPrivatePension: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    privatePensionNotCustomer: {
      label: (label: string, url: string) => `${label}|${url}`,
    },
    supplementaryMaterial: {
      label: (label: string) => `Material Suplem|${label}`,
    },
    search: {
      label: (label: string) => `Busca|${label}`,
    },
    contribuition: {
      label: (label: string) => `Fazer novo aporte|${label}`,
    },
  },
  myAdvisory: {
    action: 'MyAdvisory',
    product: 'Estratégia atual da carteira sem informações',
  },
  investment: {
    action: 'Investimentos',
    product: 'Estratégia atual da carteira sem informações',
  },
};
